import { Plus, Trash2, ChevronUp, ChevronDown, Save } from "lucide-react";
import { useCrud } from "./useCrud";
import { Field } from "./ImageField";

const Actions = ({ prefix, idx, onSave, onUp, onDown, onDelete }) => (
  <div className="flex items-center gap-2">
    <button onClick={onSave} data-testid={`${prefix}-save-${idx}`} className="inline-flex items-center gap-2 font-feature text-xs uppercase tracking-widest bg-teal/90 text-obsidian px-4 py-2 hover:bg-teal"><Save className="h-4 w-4" /> Save</button>
    <button onClick={onUp} data-testid={`${prefix}-up-${idx}`} className="p-2 border border-[#2A201A] hover:border-teal hover:text-teal transition-colors"><ChevronUp className="h-4 w-4" /></button>
    <button onClick={onDown} data-testid={`${prefix}-down-${idx}`} className="p-2 border border-[#2A201A] hover:border-teal hover:text-teal transition-colors"><ChevronDown className="h-4 w-4" /></button>
    <button onClick={onDelete} data-testid={`${prefix}-delete-${idx}`} className="ml-auto p-2 border border-[#2A201A] text-[#8F877C] hover:border-destructive hover:text-destructive transition-colors"><Trash2 className="h-4 w-4" /></button>
  </div>
);

export const LoreEditor = () => {
  const { items, patch, add, save, remove, move } = useCrud("lore", { label: "New Chapter", title: "Untitled", body: "" });
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center gap-4">
        <p className="text-[#8F877C] text-sm">Edit the Lore page story. Each card is one chapter. Separate paragraphs with a <span className="text-bone">blank line</span>, and start a line with <span className="text-teal">- </span> for a bullet point.</p>
        <button onClick={add} data-testid="lore-add" className="inline-flex shrink-0 items-center gap-2 font-feature text-xs uppercase tracking-widest bg-teal text-obsidian px-4 py-2.5 hover:bg-bone transition-colors"><Plus className="h-4 w-4" /> Add Chapter</button>
      </div>
      {items.map((it, idx) => (
        <div key={it.id} data-testid={`lore-edit-${idx}`} className="border border-[#2A201A] bg-surface/40 p-5 space-y-3">
          <div className="grid gap-3 sm:grid-cols-[160px_1fr]">
            <Field label="Label" value={it.label} onChange={(v) => patch(it.id, "label", v)} placeholder="Chapter 001" />
            <Field label="Title" value={it.title} onChange={(v) => patch(it.id, "title", v)} placeholder="Beneath the Aurora" />
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-widest text-[#8F877C] mb-2">Body (blank line = new paragraph)</p>
            <textarea value={it.body} onChange={(e) => patch(it.id, "body", e.target.value)} rows={14}
              data-testid={`lore-body-${idx}`}
              className="w-full bg-obsidian border border-[#2A201A] px-3 py-2.5 text-sm leading-relaxed text-bone focus:outline-none focus:border-teal resize-y font-body" />
          </div>
          <Actions prefix="lore" idx={idx} onSave={() => save(it)} onUp={() => move(idx, -1)} onDown={() => move(idx, 1)} onDelete={() => remove(it.id)} />
        </div>
      ))}
    </div>
  );
};
